import { language } from './config';
import getCookie from './getCookie';

export const baseCurrency: 'EUR' | 'USD' = document.querySelector('html').getAttribute('data-base-currency') as 'EUR' | 'USD' || 'EUR'
export const currency = getCookie("userCurrency") || baseCurrency
export const isUSLocale = document.querySelector('html').getAttribute('data-locale') === 'en-US'

export const formatCurrency = (val: number) => new Intl.NumberFormat(language, { style: 'currency', currency }).format(val).replace(" ","\xa0").trim()
